import React, {useEffect} from 'react'
import {Box} from '@material-ui/core'
import {Swiper} from 'swiper/bundle'
import {SwiperOptions} from 'swiper'
import {One, Two, Three, Four} from './pages'

const App = () => {
  const options: SwiperOptions = {
    direction: 'vertical',
    mousewheel: false,
    speed: 500,
    effect: 'fade',
    roundLengths: true,
    slidesPerView: 'auto',
    allowTouchMove: false,
    centeredSlidesBounds: true,
    followFinger: false,
    lazy: {
      loadOnTransitionStart: true,
    },
    keyboard: false,
    hashNavigation: false,
  }

  useEffect(() => {
    new Swiper('.slider-page', options)
  }, [])

  return (
    <React.Fragment>
      {/* <Hidden smDown>*/}
      {/*  <Box position={'absolute'} className={'mouse-container'}>*/}
      {/*    <svg width="26" height="40" viewBox="0 0 26 40" fill="none" xmlns="http://www.w3.org/2000/svg">*/}
      {/*      <rect x=".5" y=".5" width="25" height="39" rx="8.5" stroke="#fff"></rect>*/}
      {/*      <g className="animated bounce repeat-2 delay-2s">*/}
      {/*        <path d="M13.378 20.564a.5.5 0 01-.756 0l-1.504-1.737a.5.5 0 01.378-.827h3.008a.5.5 0 01.378.827l-1.504 1.737z" fill="#fff"></path>*/}
      {/*        <path d="M13.378 10.564a.5.5 0 01-.756 0l-1.504-1.737A.5.5 0 0111.496 8h3.008a.5.5 0 01.378.827l-1.504 1.737z" fill="#fff"></path>*/}
      {/*        <path d="M13.378 15.564a.5.5 0 01-.756 0l-1.504-1.737a.5.5 0 01.378-.827h3.008a.5.5 0 01.378.827l-1.504 1.737z" fill="#fff"></path>*/}
      {/*      </g>*/}
      {/*    </svg>*/}
      {/*  </Box>*/}
      {/* </Hidden>*/}
      <Box className={'slider-page swiper-container'}>
        <Box className={'swiper-wrapper'}>
          <Box className={'swiper-slide page-one'} data-hash="page-one">
            <One />
          </Box>

          <Box className={'swiper-slide page-two'} data-hash="page-two">
            <Two />
          </Box>

          <Box className={'swiper-slide page-three'} data-hash="page-three">
            <Three />
          </Box>

          <Box className={'swiper-slide page-four'} data-hash="page-four">
            <Four />
          </Box>
        </Box>
      </Box>
    </React.Fragment>
  )
}

export default App
